// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"93095302","78":"69b02a56","150":"eee616f8","184":"fe96c192","649":"a03f8121","728":"4c6110b1"}[chunkId] + ".chunk.js";
};